import React, { useState, useEffect, useRef } from 'react';
import TR from '../../Trans';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import performanceStore from '../../stores/performance';

function HorizontalListItem(props) {

  const containerRef = useRef(null);

  const setMaxWidth = (e) => {
    containerRef.current.style.maxWidth = e.target.offsetWidth + "px";
  };

  return (
    <Card id={props.id} className={props.isChosen ? "muvika-horizontal-list-item muvika-horizontal-list-item-chosen" : "muvika-horizontal-list-item"} onClick={props.onClick}>
      <img onLoad={setMaxWidth} className="muvika-horizontal-list-item-img" src={props.image} alt="" />
      <CardContent ref={containerRef} className="muvika-horizontal-list-item-content">
        <Typography className="muvika-horizontal-list-item-primary" variant="body" color="text.primary">
          {props.primary}
        </Typography>
        <Typography className="muvika-horizontal-list-item-secondary" variant="body2" color="text.secondary">
          {props.secondary}
        </Typography>
      </CardContent>
    </Card>
  );
}

export default HorizontalListItem;